import { render, staticRenderFns } from "./statistical-analysis-skeleton-table.vue?vue&type=template&id=639ed3d8&scoped=true&"
import script from "./statistical-analysis-skeleton-table.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-skeleton-table.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-skeleton-table.scss?vue&type=style&index=0&id=639ed3d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639ed3d8",
  null
  
)

export default component.exports